export var MicrophonePermissionStateValue;
(function (MicrophonePermissionStateValue) {
    MicrophonePermissionStateValue["prompt"] = "prompt";
    MicrophonePermissionStateValue["promptWithRationale"] = "prompt-with-rationale";
    MicrophonePermissionStateValue["granted"] = "granted";
    MicrophonePermissionStateValue["denied"] = "denied";
    MicrophonePermissionStateValue["limited"] = "limited";
})(MicrophonePermissionStateValue || (MicrophonePermissionStateValue = {}));
//# sourceMappingURL=definitions.js.map